import { ActivityLinkButton } from 'src/models/activityLink';
import { AbstractCommand } from 'src/models/command';

class CreateANewLinkedTaskCommand extends AbstractCommand {
	public apiVersion = 2;
	readonly name = 'IFS_DesktopModule_Task_Command_Command_CreateANewTaskCommand';

	public constructor(authenticatedUserId: number, activityLinkButton: ActivityLinkButton) {
		super();
		const originLinks = Array.isArray(activityLinkButton.originLinks)
			? activityLinkButton.originLinks
			: [
					{
						originEntryId: activityLinkButton.originEntryId,
						originModuleName: activityLinkButton.originModuleName,
					},
				];
		this.parameters = {
			activitylinkButton: {
				...activityLinkButton,
				originLinks,
			},
			changeable: false,
			content: '',
			forerunTime: 0,
			inactive: true,
			moduleLayout: 'task',
			ownerUserId: 0,
			responsibleUserId: authenticatedUserId,
			title: '',
		};
	}
}

export { CreateANewLinkedTaskCommand };
